export default __webpack_public_path__ + "static/media/待处理 (1).4422a92c.svg";